module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/close-281.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/css/close.md
// module id = 723
// module chunks = 456